// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5892":"260aa4ea","7371":"2ce6505f"}[chunkId] + ".chunk.css";
};